import * as ReactGA from 'react-ga';

// See https://github.com/react-ga/react-ga/blob/master/demo/app/withTracker.jsx
export function withTracker(page) {
    ReactGA.pageview(page);
}
